import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-transfer-success-icon',
    templateUrl: './transfer-success-icon.component.html',
    styleUrls: ['./transfer-success-icon.component.scss'],
    standalone: false
})
export class TransferSuccessIconComponent implements OnInit {
  @Input() imageSrc!: string;
  @Input() imageWidth!: number;
  @Input() imageHeight!: number;
  constructor() {}

  ngOnInit() {
    this.imageSrc =
      '../../../../assets/Icons/transfer-success-icon-200x200.png';
  }
}
